/* Dawn remains the owner of variant selection, cart submission and app integration. */
if (!customElements.get('bgp-purchase')) {
  customElements.define('bgp-purchase', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.closest('.bgp');
      this.bar = this.querySelector('[data-bgp-sticky]');
      this.target = this.root.querySelector('.product-form__buttons');
      this.price = this.root.querySelector('[id^="price-"]');
      this.picker = this.root.querySelector('variant-radios, variant-selects');
      this.templates = Array.from(this.querySelectorAll('template[data-variant]'));
      this.update = this.update.bind(this);
      this.root.addEventListener('change', this.update, { signal: this.abort.signal });
      this.observer = new MutationObserver(this.update);
      if (this.price) this.observer.observe(this.price, { childList: true, subtree: true, attributes: true });
      if (this.target) this.observer.observe(this.target, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
      this.visible = true;
      window.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          if (this.target) this.visible = this.target.getBoundingClientRect().bottom > 0;
          this.updateVisibility();
        });
      }, { passive: true, signal: this.abort.signal });
      if (this.target && 'IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting || entry.boundingClientRect.top > 0;
          this.updateVisibility();
        });
        this.intersection.observe(this.target);
      }
      this.overlayObserver = new MutationObserver(() => this.updateVisibility());
      this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.querySelectorAll('details, cart-notification, cart-drawer, product-modal, modal-dialog, [role="dialog"]').forEach(el => {
        this.overlayObserver.observe(el, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
      });
      this.bar?.querySelector('a').addEventListener('click', () => {
        this.root.querySelector('variant-radios input:checked, variant-selects select, input[name="quantity"], button[name="add"]')?.focus({ preventScroll: true });
        this.emit('bgp_sticky_click', { action: 'purchase_form' });
      }, { signal: this.abort.signal });
      window.addEventListener('popstate', () => window.location.reload(), { signal: this.abort.signal });
      const details = document.querySelector('[data-bgp-details]');
      if (details && 'IntersectionObserver' in window) {
        this.sectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.emit('bgp_section_view', { section_key: entry.target.dataset.bgpSection });
            this.sectionObserver.unobserve(entry.target);
          });
        }, { threshold: 0.1 });
        details.querySelectorAll('[data-bgp-section]').forEach(el => this.sectionObserver.observe(el));
        details.querySelectorAll('[data-bgp-faq]').forEach(el => el.addEventListener('toggle', () => {
          if (el.open) this.emit('bgp_faq_open', { question_key: el.dataset.bgpFaq });
        }, { signal: this.abort.signal }));
      }
      this.update();
    }
    emit(name, data) {
      // Local integration hook only. No analytics vendor or duplicate ecommerce event.
      this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { ...data, product_id: this.dataset.productId, template_version: 'bgp-1', device: matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop' } }));
    }
    update() {
      const id = this.picker ? this.picker.currentVariant?.id : this.root.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const initial = !this.picker || !Object.hasOwn(this.picker, 'currentVariant');
      const selected = String(initial ? this.root.querySelector('form[action*="/cart/add"] [name="id"]')?.value : id);
      const template = this.templates.find(t => t.dataset.variant === selected);
      if (template && selected !== this.lastVariant) {
        const fragment = template.content;
        const conditions = this.root.querySelector('[id^="bgp-conditions-"]');
        const source = fragment.querySelector('[data-conditions]');
        if (conditions && source) conditions.innerHTML = source.innerHTML;
        const specs = document.querySelector('[data-bgp-details] [data-bgp-specs]');
        const sourceSpecs = fragment.querySelector('[data-specs]');
        if (specs && sourceSpecs) specs.innerHTML = sourceSpecs.innerHTML;
        if (this.lastVariant) this.emit('bgp_variant_change', { variant_id: selected });
        this.lastVariant = selected;
      } else if (!template && !initial) {
        const conditions = this.root.querySelector('[id^="bgp-conditions-"]');
        if (conditions) conditions.textContent = window.variantStrings.unavailable;
        this.lastVariant = null;
      }
      if (this.bar) {
        const label = this.bar.querySelector('[data-bgp-label]');
        const price = this.bar.querySelector('[data-bgp-price]');
        label.textContent = template?.dataset.title || window.variantStrings.unavailable;
        price.textContent = template?.dataset.price || '';
      }
      this.updateVisibility();
    }
    updateVisibility() {
      if (!this.bar) return;
      const overlay = document.querySelector('details[open].menu-opening, cart-notification.active, cart-drawer.active, product-modal[open], modal-dialog[open], [role="dialog"][aria-modal="true"]:not([aria-hidden="true"])');
      const blocked = overlay && overlay.getClientRects().length > 0;
      this.bar.hidden = this.visible || Boolean(blocked) || /overflow-hidden/.test(document.body.className);
      const line = document.querySelector('.CustomizedFixedBox');
      if (line) {
        if (this.oldLineBottom === undefined) this.oldLineBottom = line.style.bottom;
        line.style.bottom = !this.bar.hidden && matchMedia('(max-width: 989px)').matches ? `${this.bar.offsetHeight + 16}px` : this.oldLineBottom;
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); this.overlayObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.sectionObserver?.disconnect();
      const line = document.querySelector('.CustomizedFixedBox');
      if (line && this.oldLineBottom !== undefined) line.style.bottom = this.oldLineBottom;
    }
  });
}
